"use client"

import { WebsiteNav } from "@/components/website-nav"
import { BulkProcessingFlow } from "@/components/bulk-processing-flow"
import { PageHeader } from "@/components/page-header"

export default function BulkProcessingPage() {
  return (
    <div className="min-h-screen bg-[#F3F6FA]">
      <WebsiteNav />

      <PageHeader
        eyebrow="Bulk processing"
        title="Bulk Payroll"
        description="Upload your team data and generate payroll reports, statutory filings, and payslips in one go. Download a template, fill it in, and process everything at once."
      />

      <section className="bg-white">
        <div className="mx-auto max-w-5xl px-5 py-10 sm:px-8 lg:px-12 lg:py-14">
          <BulkProcessingFlow />
        </div>
      </section>
    </div>
  )
}